module.exports = __webpack_public_path__ + "fonts/749ce1efae29056724f3cef35479e386.svg";